import * as React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import IconButton from "components/common/IconButton";
import useServerText from "util/serverText";
const Container = styled.span(
  ({ theme }) => css`
    display: flex;
    padding: 10px;
    background-color: ${theme.colors.table.row.background};

    &:nth-of-type(even) {
      background-color: ${theme.colors.table.row.backgroundStriped};
    }
  `
);
const Header = styled.div`
  flex: 1;
  margin-right: 5px;
`;
const Description = styled.span`
  flex: 2;
`;
const StyledDeleteButton = styled(IconButton)`
  flex: 0 0 auto;
`;
const BUILT_IN_ROLES_NAMESPACES = ["builtin_roles"];
const PaginatedItem = ({ item: { name, description }, onDeleteItem = void 0, item }) => {
  const { t } = useTranslation("common");
  const serverText = useServerText(BUILT_IN_ROLES_NAMESPACES);
  const deleteButton = typeof onDeleteItem === "function" ? /* @__PURE__ */ React.createElement(StyledDeleteButton, { onClick: () => onDeleteItem(item), name: "close", title: t("actions.remove_item", { name }) }) : null;
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Header, null, name), /* @__PURE__ */ React.createElement(Description, null, serverText(description)), deleteButton);
};
export default PaginatedItem;
